var _excluded = ["alignment", "children", "className", "defaultValue", "name", "onChange", "value"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import useStyles from './use_styles';
import useControlled from '../utils/use_controlled';
import { jsx as ___EmotionJSX } from "@emotion/core";
var RadioButtons = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
      alignment = 'vertical',
      children,
      className,
      defaultValue,
      name,
      onChange,
      value: valueProp
    } = _ref,
    rootProps = _objectWithoutProperties(_ref, _excluded);
  var [value, setValue] = useControlled({
    controlled: valueProp,
    default: defaultValue
  });
  var handleChange = React.useCallback(event => {
    setValue(event.target.value);
    onChange === null || onChange === void 0 || onChange(event, event.target.value);
  }, [onChange, setValue]);
  var prepareChildren = () => {
    var childrenArray = [];
    React.Children.forEach(children, (child, index) => {
      if ( /*#__PURE__*/React.isValidElement(child)) {
        var checked = typeof value === 'undefined' ? false : child.props.value === value;
        var clonedProps = {
          checked,
          name,
          onChange: handleChange,
          key: "".concat(name, "-").concat(index)
        };
        var clonedChild = /*#__PURE__*/React.cloneElement(child, clonedProps);
        childrenArray.push(clonedChild);
      }
    });
    return childrenArray;
  };
  var style = useStyles({
    alignment
  });
  return ___EmotionJSX("div", _extends({}, rootProps, {
    className: className,
    css: style.root,
    ref: ref,
    role: "radiogroup"
  }), prepareChildren());
});
RadioButtons.displayName = 'RadioButtons';
export default RadioButtons;